// frontend/src/pages/ContentTypeProductsPage.js
import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import apiClient from '../api/apiClient';
import LoadingSpinner from '../components/common/LoadingSpinner';
import VerticalContentCard from '../components/Category/VerticalContentCard';
import ContentFilters from '../components/common/ContentFilters';

// تابع کمکی برای تبدیل content_type به عنوان فارسی
const getContentTypeTitle = (type) => {
  const titles = {
    'WRITTEN': 'آثار مکتوب',
    'VIDEO': 'ویدیوها',
    'LECTURE': 'درس گفتارها',
  };
  return titles[type] || 'محصولات';
};

const ContentTypeProductsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const contentType = searchParams.get('content_type');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    sortOrder: 'newest',
    isFree: null,
  });

  useEffect(() => {
    if (!contentType) {
      setError('نوع محتوا مشخص نشده است.');
      setLoading(false);
      return;
    }

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const params = {
          content_type: contentType,
          sort_by: filters.sortOrder,
          ...(filters.isFree !== null && { is_free: filters.isFree })
        };
        const response = await apiClient.get('/products/list/', { params });
        const productsData = response.data.results || response.data;
        setProducts(Array.isArray(productsData) ? productsData : []);
      } catch (err) {
        console.error(err);
        setError('خطا در بارگذاری محتوا');
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [contentType, filters]);

  if (loading) return <LoadingSpinner text="در حال بارگذاری..." />;
  if (error) return <div className="text-center text-red-600 p-4">{error}</div>;

  const pageTitle = getContentTypeTitle(contentType);

  return (
    <div className="rtl container mx-auto p-4 pb-20 max-w-[460px] overflow-x-hidden bg-white">
      {/* Breadcrumb */}
      <div className="p-4 bg-white border-b border-gray-200">
        <nav className="text-sm font-light text-gray-500 mb-2 flex items-center space-x-reverse space-x-1">
          <Link to="/" className="hover:text-indigo-600">خانه</Link>
          <ChevronLeft size={14} className="mt-0.5 text-gray-400" />
          <span className="text-gray-800 font-medium">{pageTitle}</span>
        </nav>
        <h1 className="text-2xl font-extrabold text-gray-800 truncate">
          {pageTitle}
        </h1>
      </div>

      <ContentFilters filters={filters} setFilters={setFilters} />

      <div className="p-4 md:p-6">
        {products.length === 0 ? (
          <div className="text-center text-gray-500 py-10">
            <p>هیچ محتوایی در این دسته‌بندی یافت نشد.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {products.map(product => (
              <VerticalContentCard key={product.id || product.slug} data={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentTypeProductsPage;